import axios from 'axios';

type Props = {
    id: string;
    rotaryCd: string;
}

/**
 * 未申込のイベントのリストを取得するAPI
 * @param param0
 * @returns 
 */
export async function getNotYetEventData({id, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/mypage/event/notyet` , {
        params: {
            rotaryCd: rotaryCd,
            paramId: id
        },
        paramsSerializer:{
            indexes: null
        }
    })
    return JSON.parse(JSON.stringify(response.data))
}